import axios from "axios";
import Vue from 'vue';

// Video on how to use Vue state: https://www.youtube.com/watch?v=5lVQgZzLMHc

const state = {
  votes: {
    IN: -1,
    KY: -1,
    OH: 1,
    musical: -1,
    static: -1
  },
  position: {
    lat: -1,
    lng: -1,
    valid: false
  },
  fbid: -1,
  fbname: "Unknown",
  displaysById: {},
  categoryVotes: {
    IN: [],
    KY: [],
    OH: [],
    musical: [],
    static: []
  },
  sort: "votes",
  showMusicalOnly: false,
  displays: [
    {
      displayid: 1,
      title: "Loading.....",
      votes: 0
    }
  ],
  loaded: false,
  active: [
    {
      displayid: 1,
      title: "Loading.....",
      votes: 0,
      videos: [],
      images: []
    }
  ]
};

function getDisplay(id) {
  let key = "disp" + id;
  if (key in state.displaysById) {
    return state.displaysById[key];
  }
  return {
    displayid: -1,
    title: "None"
  };
}

function actualSort(input) {
  if (input == "votes") {
    state.displays.sort((a, b) =>
      a.votes < b.votes
        ? 1
        : a.votes > b.votes
        ? -1
        : a.title > b.title
        ? 1
        : -1
    );
  } else if (input == "location") {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(function(position) {
        state.position.lat = position.coords.latitude;
        state.position.lng = position.coords.longitude;
        state.position.valid = true;
        state.displays.forEach(e => {
          e.distance =
            Math.round(
              distance(state.position.lat, state.position.lng, e.lat, e.lng) *
                10
            ) / 10;
          e.distanceDescription = e.distance + " miles";
        });
        state.displays.sort((a, b) => (a.distance > b.distance ? 1 : -1));
      });
    } else {
      alert("Geolocation is not supported by this browser.");
    }
  } else {
    state.displays.sort((a, b) => (a.title > b.title ? 1 : -1));
  }
  return state.displays;
}

function deg2rad(degrees) {
  return degrees * (Math.PI / 180);
}
function rad2deg(rad) {
  return (rad * 180) / Math.PI;
}

function distance(lat1, lon1, lat2, lon2) {
  let theta = lon1 - lon2;
  let dist =
    Math.sin(deg2rad(lat1)) * Math.sin(deg2rad(lat2)) +
    Math.cos(deg2rad(lat1)) *
      Math.cos(deg2rad(lat2)) *
      Math.cos(deg2rad(theta));
  dist = Math.acos(dist);
  dist = rad2deg(dist);
  let miles = dist * 60 * 1.1515;

  return miles;
}
function mapCategory(m, cat) {
  let rc = [];
  m[cat].forEach(e => {
    if (rc.length > 2) {
      return;
    }
    let disp = getDisplay(e.displayid);
    disp = JSON.parse(JSON.stringify(disp)); // clone to set votes
    disp.votes = e.cnt;
    rc.push(disp);
  });
  return rc;
}

const getters = {
  allDisplays: state => {
    if (state.showMusicalOnly) {
      return state.displays.filter(e => e.isMusical == true);
    } else {
      return state.displays;
    }
  },
  getMusicalOnly: state => state.showMusicalOnly,
  getActive: state => state.active,
  isLoaded: state => state.loaded,
  getFbId: state => state.fbid,
  getVotes: state => state.votes,
  getKYVotes: state => {
    return mapCategory(state.categoryVotes, "KY");
  },
  getOHVotes: state => {
    return mapCategory(state.categoryVotes, "OH");
  },
  getINVotes: state => {
    return mapCategory(state.categoryVotes, "IN");
  },
  getmusicalVotes: state => {
    return mapCategory(state.categoryVotes, "musical");
  },
  getstaticVotes: state => {
    return mapCategory(state.categoryVotes, "static");
  },
  getVotedDisplays: state => {
    return {
      KY: getDisplay(state.votes.KY),
      IN: getDisplay(state.votes.IN),
      OH: getDisplay(state.votes.OH),
      musical: getDisplay(state.votes.musical),
      static: getDisplay(state.votes.static)
    };
  }
};

async function doLoad() {
  let r = await axios.get(
    "https://cooldisplays.net/api.php?displays=y&tags=n&asList=Y&showTags=Y&activeOnly=Y&lat=39.1031&lng=-84.5120&maxDistance=100"
  );
  let v = await axios.get("https://cooldisplays.net/cinci/votes.php");
  return {
    displays: r.data.displays,
    votes: v.data.allVotes,
    categoryVotes: v.data.categoryVotes
  };
}

const actions = {
  async faceBookLogin({ commit }, props) {
    let url = "https://cooldisplays.net/cinci/votes.php?userid=" + props.id;
    let r = await axios.get(url);
    let me = r.data.me;
    // Load votes here
    commit("setFaceBook", {
      id: props.id,
      name: props.name,
      votes: me.votes
    });
  },
  async fetchState({ commit }) {
    if (state.displays.length < 5) {
      commit("setDisplays", await doLoad());
      commit("setSort", state.sort);
    }
  },
  async removeVote(context, info) {
    let v = context.state.votes;
    if (info.type == "KY") {
      v.KY = -1;
    } else if (info.type == "IN") {
      v.IN = -1;
    } else if (info.type == "OH") {
      v.OH = -1;
    } else if (info.type == "musical") {
      v.musical = -1;
    } else if (info.type == "static") {
      v.static = -1;
    }
    // Ajax call here
    let payload = {
      id: context.state.fbid,
      name: context.state.fbname,
      votes: v
    };
    let r = await axios.post(
      "https://cooldisplays.net/cinci/vote.php",
      payload
    );

    context.commit("setVotes", r.data.me.votes);
    context.commit("setDisplays", {
      displays: context.state.displays,
      votes: r.data.allVotes,
      categoryVotes: r.data.categoryVotes
    });
    context.commit("setActive", context.state.active[0].displayid); // Refresh vote on page
  },
  async setMusicalOnly(context, value) {
    context.state.showMusicalOnly = value;
    context.commit("setSort", context.state.sort);
  },

  async addVote(context, info) {
    let v = context.state.votes;
    if (info.type == "KY") {
      v.KY = info.id;
    } else if (info.type == "IN") {
      v.IN = info.id;
    } else if (info.type == "OH") {
      v.OH = info.id;
    } else if (info.type == "musical") {
      v.musical = info.id;
    } else if (info.type == "static") {
      v.static = info.id;
    }
    // Ajax call here
    let payload = {
      id: context.state.fbid,
      name: context.state.fbname,
      votes: v
    };
    let r = await axios.post(
      "https://cooldisplays.net/cinci/vote.php",
      payload
    );

    context.commit("setVotes", r.data.me.votes);
    context.commit("setDisplays", {
      displays: context.state.displays,
      votes: r.data.allVotes,
      categoryVotes: r.data.categoryVotes
    });
    context.commit("setActive", context.state.active[0].displayid); // Refresh vote on page
  },
  async setActive(context, id) {
    if (!context.state.loaded) {
      context.commit("setDisplays", await doLoad());
      context.commit("setSort", context.state.sort);
    }
    context.commit("setActive", id);
  },
  async sortByTitle({ commit }) {
    commit("setSort", "title");
  },
  async sortByVotes({ commit }) {
    commit("setSort", "votes");
  },
  async sortByLocation({ commit }) {
    commit("setSort", "location");
  }
};

const mutations = {
  setFaceBook: (state, input) => {
    state.fbid = input.id;
    state.fbname = input.name;
    state.votes = input.votes;
  },
  setSort: (state, input) => {
    state.sort = input;
    state.displays = actualSort(input);
  },
  setVotes: (state, input) => {
    state.votes = input;
  },
  setDisplays: (state, input) => {
    state.displays = input.displays;
    var vote_by_id = [];
    input.votes.forEach(function(e) {
      let key = "d" + e.displayid;
      vote_by_id[key] = e.cnt;
    });

    var dispById = {};

    state.displays.forEach(e => {
      key = "disp" + e.displayid;
      dispById[key] = e;
      // Check if musical
      e.isMusical = e.tags.includes("Synced to Music");
      e.isExclude = e.tags.includes("Commercial");
      e.distance = -1;
      let distanceDescription = "";

      if (state.position.valid) {
        e.distance =
          Math.round(
            distance(state.position.lat, state.position.lng, e.lat, e.lng) * 10
          ) / 10;
        distanceDescription = e.distance + " miles";
      }
      Vue.set(e, 'distanceDescription', distanceDescription);
      let addr = e.street + " " + e.city + ",  " + e.state + " " + e.zip;
      e.coolUrl =
        "https://cooldisplays.net/index.php?page=single&id=" + e.displayid;
      e.directionUrl = "https://maps.google.com/maps?daddr=" + encodeURI(addr);
      e.displayImage =
        "https://cooldisplays.net/picture.php?width=500&display=" + e.displayid;
      e.previewImage =
        "https://cooldisplays.net/picture.php?width=250&display=" + e.displayid;

      e.votes = 0;
      let key = "d" + e.displayid;
      if (key in vote_by_id) {
        e.votes = parseInt(vote_by_id[key]);
      }
    });
    state.categoryVotes = input.categoryVotes;
    state.displays = state.displays.filter(e => e.isExclude == false);
    state.displaysById = dispById;
    state.loaded = true;
  },
  setActive: (state, id) => {
    state.displays.forEach(e => {
      if (e.displayid === id) {
        state.active = [e];
      }
    });
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
